<div class="pv-input" [formGroup]="form">
	@if (label) {
		<ic-label [help]="help" [missing]="missing" [missingText]="missingText" [required]="required">
			{{ label }}
		</ic-label>
	}
	<div class="inputs">
		<div class="border">
			<i aria-hidden="true" class="fa fa-clock-o" [class.disabled]="disabled"> </i>
			<input
				formControlName="hours"
				min="0"
				placeholder="{{ 'labels.organisationStructure.room.amount' | translate }}"
				type="number2"
				[class]="inputClass"
				[disabled]="disabled"
				(blur)="onTouched()"
				(input)="onChange()"
			/>
			<span> {{ "labels.time.hours" | translate }} </span>
		</div>
		<div class="border">
			<i aria-hidden="true" class="fa fa-clock-o" [class.disabled]="disabled"> </i>
			<input
				formControlName="minutes"
				min="0"
				placeholder="{{ 'labels.organisationStructure.room.amount' | translate }}"
				type="number2"
				[class]="inputClass"
				[disabled]="disabled"
				(blur)="onTouched()"
				(input)="onChange()"
			/>
			<span> {{ "labels.time.minutes" | translate }} </span>
		</div>
	</div>
	<ng-content select=".errors" />
</div>
